import http from './http'

const configurationRoute = '/configuration/'

export default {
    async getConfiguration (query) {
        if (query.identifier === undefined) { return http.get(configurationRoute + query.section) }
        return http.get(configurationRoute + query.section + '?identifier=' + query.identifier)
    }
}
